// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const suppressLdErrors: (...args: any[]) => void = (error) => {
  // https://support.launchdarkly.com/hc/en-us/articles/12998125691419-Error-LaunchDarklyFlagFetchError-network-error
  const ignoredErrors = ['LaunchDarklyFlagFetchError'];
  if (!ignoredErrors.includes(error.name)) {
    console.error('[LaunchDarkly Error]', error);
  }
};
